<template>
    <div class="wrapper">
        <page>
            <div slot="page-content-w100">
                <h1 v-if="browser_size != 'small'" class="fsl32">{{$t('Explore.text1')}}</h1>
                <search-bar v-if="browser_size == 'small'" :is_show_submit="false" :is_clear_after_submit="true" @click.native="search"/>
                <!-- <div class="flex-box mt32"> -->
                    <!-- <nav-tab-item
                        tag="div"
                        class="fs24"
                        :text="$t('Explore.text2')"
                        :class="{ on: type == 'hot' }"
                        @click.native="tab_type('hot')"
                    ></nav-tab-item>
                    <nav-tab-item
                        tag="div"
                        class="fs24"
                        :text="$t('Explore.text3')"
                        :class="{ on: type == 'rec' }"
                        @click.native="tab_type('rec')"
                    ></nav-tab-item> -->
                    <div
                        v-if="GL.ENV.is_iPad"
                        style="margin-top: 32px;"
                        class="flex-box flex-item-1 flex-direction-row-reverse"
                        @click="$mixin_router_push(`/search`)"
                    >
                        <btn>{{$t('Explore.text4')}}</btn>
                    </div>
                    <!-- <nav-tab-item tag="div" class="fs24" text="新入驻" :class="{on:type == 'new'}" @click.native="tab_type('new')"></nav-tab-item> -->
                <!-- </div> -->
                <div class="content-wrapper">
                    <div class="content-left">
                        <category-select
                            class="mt32"
                            ref="category_select"
                            :list="category_list"
                            v-click-outside="close_category_select"
                            @change="category_change"
                        ></category-select>
                    </div>
                    <div class="content-right mt-16-0 mq">
                        <div class="content-box mb16">
                            <template v-if="user_list.length > 0">
                                <div
                                    @click="
                                        $mixin_router_push(`/a/${user.url_slug}`)
                                    "
                                    class="item-box"
                                    v-for="user in user_list"
                                    :key="user.user_id"
                                >
                                    <avatar-business-card
                                        :user="user"
                                        :is_no_href="true"
                                    ></avatar-business-card>
                                </div>
                            </template>
                        </div>
                        <div class="relative" v-if="is_loading">
                            <div class="loading-box">
                                <img
                                    style="
                                        width: 50px;
                                        height: 50px;
                                        margin-left: -25px;
                                    "
                                    src="/static/img/asset/loding.png"
                                    class="loading self-center-loading"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </page>
    </div>
</template>

<script>
import { GET_CREATOR_LIST, GET_CATEGORY_LIST } from "../api/config";
import { mapState } from "vuex";
export default {
    name: "explore",
    metaInfo() {
        let tit = `发现创作者 | 爱发电`;
        let key = `爱发电，订阅，创作者，赞助，粉丝，视频，文章，小说，音乐，绘画，动漫，摄影，游戏，艺术`;
        let desc = `将创作的自由还给创作者！爱发电是让创作者简单地获得稳定收入的粉丝赞助平台。无论你在创作什么，都能在这里获得持续的资金支持，让创作从此更自由。`;
        let url = location.href;
        return {
            title: tit,
            meta: [
                {
                    name: "keywords",
                    content: key,
                },
                {
                    property:'og:title',
                    content: tit,
                },
                {
                    property:'og:description',
                    content: desc,
                },
                {
                    property:'og:url',
                    content: url,
                }
            ],
        };
    },
    data() {
        return {
            user_list: [],
            category_list: [],
            page: 1,
            type: "hot",
            has_more: 1,
            is_loading: false,
            stickyConfig: {
                zIndex: 100,
                stickyTop: 100,
            },
            category_id: "",
        };
    },
    computed: {
        ...mapState("app", ["session_user", "browser_size"]),
        share_config(){
            return {
                url: window.location.href,
                source: `${location.origin}`,
                title: `发现创作者 | 爱发电`,
                description: `将创作的自由还给创作者！爱发电是让创作者简单地获得稳定收入的粉丝赞助平台。无论你在创作什么，都能在这里获得持续的资金支持，让创作从此更自由。`,
                pic: `https://static.afdiancdn.com/static/img/logo/logo.png`,
            };
        },
    },
    watch: {
        type() {
            this.get_list();
        },
    },
    beforeMount() {
        this.get_list();
        this.get_category_list();
    },
    mounted() {
        this.$bus.$on("SCROLL_LOAD_MORE", () => {
            this.load_more();
        });
        this.$mixin_share(this.share_config)
    },
    beforeDestroy() {
        this.$bus.$off("SCROLL_LOAD_MORE");
    },
    methods: {
        tab_type(type) {
            this.page = 1;
            this.has_more = 1;
            this.type = type;
        },
        async get_category_list() {
            if (this.$http.is_run(GET_CATEGORY_LIST)) {
                return false;
            }
            let data = await this.$http.$axios(GET_CATEGORY_LIST);
            if (data.ec != 200) {
                this.$notify({
                    title: data.em,
                    group: "error",
                });
                return false;
            }
            this.category_list = data.data.list;
        },
        async get_list(type) {
            if (this.$http.is_run(GET_CREATOR_LIST)) {
                return false;
            }
            this.is_loading = true;
            let data = await this.$http.$axios(GET_CREATOR_LIST, {
                page: this.page,
                type: this.type,
                category_id: this.category_id,
            });
            this.is_loading = false;
            if (data.ec != 200) {
                this.$notify({
                    title: data.em,
                    group: "error",
                });
                return false;
            }
            this.has_more = data.data.has_more;
            if (type == "concat") {
                this.user_list = this.user_list.concat(data.data.list);
                return false;
            }
            this.user_list = data.data.list;
        },
        async load_more() {
            if (this.has_more && !this.mixin_scroll_busy) {
                this.mixin_scroll_busy = true;
                this.page++;
                await this.get_list("concat");
                this.mixin_scroll_busy = false;
            }
        },
        category_change(data) {
            this.category_id = data.category_id;
            this.page = 1;
            this.get_list();
        },
        close_category_select() {
            this.$refs.category_select.close();
        },
        search(data){
            // this.$mixin_router_push(encodeURI(`/search?q=${data.q}`))
            this.$mixin_router_push(encodeURI(`/search`))
        }
    },
};
</script>
<style lang="stylus" scoped>
.wrapper{
    padding-bottom px2rem(48)
    .content-right{
        width 100%
    }
    .content-box{
        width 100%
        display flex
        flex-wrap wrap
        .item-box{
            width 50%
            padding px2rem(16)
            box-sizing border-box
            margin-bottom px2rem(16)
            &:hover{
                //background $black-03
                .vm-avatar-business-card /deep/{
                    //width 48%
                    //margin-right 4%
                    //margin-bottom px2rem(16)
                    border 1px solid $purple
                }
            }
            &:nth-child(2n + 1){
                //margin-left _px2rem(16)
            }
            &:nth-child(2n){
                //margin-left px2rem(16)
            }
            .vm-avatar-business-card /deep/{
                //width 48%
                //margin-right 4%
                //margin-bottom px2rem(16)
                border 1px solid transparent
            }
        }

    }
    .vm-nav-tab-item{
        margin-right px2rem(64)
        &:last-child{
            margin-right px2rem(0)
        }
    }
    .content-wrapper{
        .content-left{
            width 280px
            min-width 280px
            max-width 280px
            margin-right px2rem(40)
        }
    }

    @media (max-width: $width-mobile){
        background: $white;
        .vm-page /deep/{
            padding 0 px2rem(16);
            &.afd-client{
                .page-box{
                    margin-top:12px;
                }
            }
        }
        .content-box{
            margin-top px2rem(24)
            .item-box{
                width 100%
                padding 0
                margin-bottom px2rem(48)
                &:hover{
                    background transparent
                }
                &:nth-child(2n + 1),
                &:nth-child(2n){
                    margin-left 0
                }
            }
        }
        .vm-nav-tab-item{
            margin-right px2rem(48)
        }
        .content-wrapper{
            .content-left{
                width 100%
                min-width 100%
                margin-right 0
            }
        }
    }
    @media (min-width: $width-mobile + 1) and (max-width: $width-pc){
        .content-box{
            margin-top px2rem(24)
            .item-box{
                width 100%
                padding 0
                margin-bottom px2rem(32)
                &:hover{
                    background transparent
                }
                &:nth-child(2n + 1),
                &:nth-child(2n){
                    margin-left 0
                }
            }
        }
    }
}
</style>
